module.exports = __webpack_public_path__ + "static/media/landing-banner-bg.4ec3a690.jpg";